import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import SearchBar from '../datatable/SearchBar';
import RelationDataTable from '../datatable/RelationDataTable';
import Thumbnail from '../thumbnail/Thumbnail';
import { COLUMN_STYLE, getColumnStyle } from '../datatable/util';

import { defaultRejectHandler, stringifyErrorMessage } from '../../utils/utility';
import { searchOtherRenewableEnergyByText } from '../../redux/renewable_energy/other_renewable_energy_actions';

import {
  addOtherRenewableEnergyToBuilding,
  editOtherRenewableEnergyInBuilding,
  listOtherRenewableEnergyInBuilding,
  removeOtherRenewableEnergyFromBuilding,
} from '../../redux/projects/project_other_renewable_energy_actions';
import { getProject } from '../../redux/projects/projects_actions';


export class OtherRenewableEnergyDataTable extends React.Component {
  constructor(props) {
    super(props);
    const { t } = props;

    this.search = {
      pageSize: this.DEFAULT_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    const textColumn = getColumnStyle(COLUMN_STYLE.text);
    const coeColumn = getColumnStyle(COLUMN_STYLE.coefficient);
    const decimalColumn = getColumnStyle(COLUMN_STYLE.decimal);

    this.columns = [
      {
        Header: '',
        accessor: 'other_renewable_energy.thumbnail',
        Cell: row => <Thumbnail img={row.value} />,
        ...getColumnStyle(COLUMN_STYLE.thumbnail),
      },
      {
        Header: () => <b>{t('name')}</b>,
        accessor: 'other_renewable_energy.name',
        ...textColumn,
        entity: {
          list: (text, page) => searchOtherRenewableEnergyByText(text, page)
            .then(response => response.data.map(({name, id}) => ({label: name, value: String(id)}))),
          create: null,
        },
      },
      {
        Header: () => <b>{t('energy')} ({t('kWh/Year')})</b>,
        accessor: 'other_renewable_energy.energy',
        ...coeColumn,
      },
      {
        Header: () => <b>{t('quantity')}</b>,
        accessor: 'quantity',
        width: 80,
        ...decimalColumn,
        attr: {
          type: 'number',
          isRequired: true,
          props: { min: 1 },
        },
      },
    ];

    this.state = {};
  }

  updateSortFilter(filter, state, category) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.filtered = filter;
    this.props.listOtherRenewableEnergy(
      this.search.pageSize,
      this.search.page,
      this.search.sorted,
      this.search.filtered,
      {
        all: null,
        public: true,
        private: false,
      }[category],
    );
    this.setState({ categoryOption: category });
  }

  render() {
    const { categoryOption } = this.state;

    const {
      buildingId,
      filtered,
      filteredCount,
      isOtherRenewableEnergyLoading,
      addOtherRenewableEnergy,
      editOtherRenewableEnergy,
      removeOtherRenewableEnergy,
      isOtherRenewableEnergyAdding,
      isOtherRenewableEnergyEditing,
      isOtherRenewableEnergyRemoving,
      errorMessage,
    } = this.props;

    const relationship = {
      create: ({ entityId, quantity }) => addOtherRenewableEnergy(entityId, buildingId, quantity),
      edit: ({ id, quantity }) => editOtherRenewableEnergy(id, quantity),
      delete: id => removeOtherRenewableEnergy(id, buildingId),
      isCreating: isOtherRenewableEnergyAdding,
      isEditing: isOtherRenewableEnergyEditing,
      isDeleting: isOtherRenewableEnergyRemoving,
    };

    return (
      <div style={{ backgroundColor: 'white' }}>
        <SearchBar onSearch={text => this.updateSortFilter(text, null, this.state.categoryOption)} />
        <RelationDataTable
          columns={this.columns}
          data={this.props.relationships}
          errorMessage={stringifyErrorMessage(errorMessage)}
          relationship={relationship}
          relationshipNameAccessor={item => item.other_renewable_energy.name}
          onActionDelete={item => this.setState({ isShowDeleteModal: true, selectedItem: item.original })}
          filteredCount={filteredCount}
          isLoading={isOtherRenewableEnergyLoading}
          onFetchData={state => this.updateSortFilter(filtered, state, categoryOption)}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  relationships: state.projectRE.otherRenewableEnergy.orderedIds.map(id => state.projectRE.otherRenewableEnergy.objects[id]),
  filteredCount: state.projectRE.otherRenewableEnergy.filteredCount,
  isOtherRenewableEnergyLoading: state.projectRE.otherRenewableEnergy.isLoading,
  isOtherRenewableEnergyAdding: state.projectRE.otherRenewableEnergy.isCreating,
  isOtherRenewableEnergyEditing: state.projectRE.otherRenewableEnergy.isEditing,
  isOtherRenewableEnergyRemoving: state.projectRE.otherRenewableEnergy.isDeleting,
  errorMessage: state.projectRE.otherRenewableEnergy.errorMessage,
});

const mapDispatchToProps = (dispatch, props) => ({
  listOtherRenewableEnergy: (pageSize, page, sorted, filtered, isPublic) =>
    defaultRejectHandler(dispatch(listOtherRenewableEnergyInBuilding(pageSize, page, sorted, filtered, isPublic, props.buildingId))),
  addOtherRenewableEnergy: (solarEnergyId, buildingId, quantity) =>
    defaultRejectHandler(dispatch(addOtherRenewableEnergyToBuilding(solarEnergyId, buildingId, quantity))
      .then(() => dispatch(getProject(props.projectId)))),
  editOtherRenewableEnergy: (buildingOtherRenewableEnergyId, quantity) =>
    defaultRejectHandler(dispatch(editOtherRenewableEnergyInBuilding(buildingOtherRenewableEnergyId, quantity))
      .then(() => dispatch(getProject(props.projectId)))),
  removeOtherRenewableEnergy: (buildingOtherRenewableEnergyId, buildingId) =>
    defaultRejectHandler(dispatch(removeOtherRenewableEnergyFromBuilding(buildingOtherRenewableEnergyId, buildingId))
      .then(() => dispatch(getProject(props.projectId)))),
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(OtherRenewableEnergyDataTable),
);



// WEBPACK FOOTER //
// ./src/components/project_detail/OtherRenewableEnergyDataTable.js